import { defineMessages } from 'react-intl';

const scope = 'app.admin.components.HBGridToolbar';

export const messages = defineMessages({
  search: {
    id: `${scope}.search`,
    defaultMessage: 'جستجو',
  },
  edit: {
    id: `${scope}.edit`,
    defaultMessage: 'ویرایش',
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: 'حذف',
  },
  update: {
    id: `${scope}.update`,
    defaultMessage: 'به روزرسانی',
  },
  create: {
    id: `${scope}.create`,
    defaultMessage: 'ایجاد',
  },
  more: {
    id: `${scope}.more`,
    defaultMessage: 'بیشتر',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'فعال',
  },
  inActive: {
    id: `${scope}.inActive`,
    defaultMessage: 'غیرفعال',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'وضعیت',
  },
});
